define([
    'jquery'
], function( $ ) {

    var self;
    function init() {
        self = this;
        self.toggle = $('.mol-accordion .mol-accordion__header');
        self.toggle.on('click', function(ev) {
            ev.preventDefault();
            toggleButtonState(ev.currentTarget);
            $.pubsub('publish', 'vfdp.wcs.mol-accordion.change');
        });
    }
    /**
     * Toggle the state of the See More/See Less button
     **/
    function toggleButtonState(target) {
        var parent = $(target.parentElement);
        var icon = $(target).find('.mol-accordion__header-arrow').first();
        var config = parent.data('config');
        var data = icon.data();
        var $body = parent.find('.mol-accordion__body');
        this.smoothExpanding = config && config.smoothExpanding == 'true' ? true : false;

        if( parent.hasClass('mol-accordion--collapsed')) {
            //Expand accordion
            if (config && config.hideUntilExpandingDuration) {
                toggleBody($body, true, function() {
                    parent.removeClass('mol-accordion--collapsed')
                    .addClass('mol-accordion--expanded visually-hidden-body');
                });

                setTimeout(function () { //Preventing visual flickering caused by the content and the expansions of the height when the accordion is expanded
                    parent.removeClass('visually-hidden-body');
                }, config.hideUntilExpandingDuration);
            }
            else{
                toggleBody($body, true, function() {
                    parent.removeClass('mol-accordion--collapsed')
                    .addClass('mol-accordion--expanded');
                });
            }
            icon.removeClass(data.closedIcon)
                .addClass(data.expandedIcon);

            if (config && config.automaticallyCollapseAccordions) {
                collapseTheRest(parent);
            }
            if( config && config.scrollIntoViewOptions){
                parent[0].scrollIntoView(config.scrollIntoViewOptions);
            }

        } else {
            //Collapse accordion
            toggleBody($body, false, function() {
                parent.removeClass('mol-accordion--expanded')
                .addClass('mol-accordion--collapsed');
            });
            icon.removeClass(data.expandedIcon)
                .addClass(data.closedIcon);
        }
    }

    function collapseTheRest(currentElement){
        var $otherAccordions = $('.mol-accordion').not(currentElement);
        var $icons = $otherAccordions.find('.mol-accordion__header-arrow');
        var data = $icons.data();

        var $otherAccordionsBody = $($otherAccordions).find('.mol-accordion__body');
        toggleBody($otherAccordionsBody, false, function() {
            $otherAccordions.removeClass('mol-accordion--expanded')
                .addClass('mol-accordion--collapsed');
        });

        $icons.removeClass(data.expandedIcon)
            .addClass(data.closedIcon);
    }

    function toggleBody(target, isExpanding, callBack) {
        var self = this;
        var smoothExpanding = self.smoothExpanding || false;
        if(smoothExpanding && target && target.length > 0) {
            if (isExpanding) {
                $(target).slideDown(400, function() {
                    callBack();
                });
            } else {
                $(target).slideUp(400, function() {
                    callBack();
                });
            }
        } else {
            callBack();
        }
    }

    init();

    return {init: init, toggleButtonState: toggleButtonState};
});
